module.exports = __webpack_public_path__ + "img/icon-facade.9a2e2405.svg";